import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

//https://stackoverflow.com/questions/34836500/how-to-set-up-google-analytics-for-react-router
const usePageTracking = () => {
  ReactGA.plugin.require("ec");
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    //const isTest = process.env.REACT_APP_ENVIRONMENT !== "production";
    ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID!, { debug: false });
    setInitialized(true);
  }, []);

  useEffect(() => {
    if (initialized) {
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [initialized, location]);
};

export default usePageTracking;
